import type { CountryConfiguration } from 'types/countryConfiguration'

import type { Size } from '../../types/FullProduct'

interface GetIsSellableColor {
	country: CountryConfiguration
	sizes: Size[]
}

export const getIsSellableColor = ({
	country,
	sizes,
}: GetIsSellableColor): boolean => {
	return Boolean(country.hasOnlineSale && sizes.some((size) => size.available))
}
